(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[366],{

/***/ 9868:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tests/created",
      function () {
        return __webpack_require__(7766);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);





var Authenticated = function(param) {
    var requiredRole = param.requiredRole, children = param.children;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isLoginChecked = ref[0], setIsLoginChecked = ref[1];
    var isVerifyingStarted = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(false);
    var redirectToLogin = function(locationPathname, authCheckFailed, requiredRole) {
        var query = {
            redirectTo: "".concat(locationPathname).concat(location.search)
        };
        if (authCheckFailed) {
            query.authCheckFailed = authCheckFailed;
        }
        if (requiredRole) {
            query.requiredRole = requiredRole;
        }
        router.push({
            pathname: "/login",
            query: query
        });
    };
    var verifyLogin = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            var rawLocationPathname, locationPathname, accessToken, authResponce, authResult, userPayload;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        rawLocationPathname = location.pathname;
                        locationPathname = rawLocationPathname.startsWith("/") ? rawLocationPathname : "/" + rawLocationPathname;
                        accessToken = localStorage.getItem("accessToken");
                        if (!accessToken || accessToken == "null" || accessToken == "undefined") {
                            return [
                                2,
                                redirectToLogin(locationPathname)
                            ];
                        }
                        return [
                            4,
                            fetch("/api/v1/auth/verify?token=".concat(accessToken))
                        ];
                    case 1:
                        authResponce = _state.sent();
                        if (!authResponce.ok) {
                            return [
                                2,
                                redirectToLogin(locationPathname, true)
                            ];
                        }
                        return [
                            4,
                            authResponce.json()
                        ];
                    case 2:
                        authResult = _state.sent();
                        if (!authResult.data.verified) {
                            redirectToLogin(locationPathname);
                        } else {
                            userPayload = authResult.data.payload;
                            if (requiredRole !== undefined && userPayload.role < requiredRole) {
                                redirectToLogin(locationPathname, false, requiredRole);
                            }
                        }
                        setIsLoginChecked(true);
                        return [
                            2
                        ];
                }
            });
        });
        return function verifyLogin() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!isVerifyingStarted.current) {
            isVerifyingStarted.current = true;
            verifyLogin();
        }
    }, [
        router,
        requiredRole
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isLoginChecked && children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Authenticated);


/***/ }),

/***/ 6448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bo": function() { return /* binding */ userRolesInRussian; },
/* harmony export */   "i4": function() { return /* binding */ UserRole; }
/* harmony export */ });
/* unused harmony export userRoles */
var UserRole;
(function(UserRole) {
    UserRole[UserRole["USER"] = 0] = "USER";
    UserRole[UserRole["MODERATOR"] = 1] = "MODERATOR";
    UserRole[UserRole["ADMIN"] = 2] = "ADMIN";
})(UserRole || (UserRole = {}));
var userRoles = (/* unused pure expression or super */ null && ([
    "User",
    "Moderator",
    "Admin"
]));
var userRolesInRussian = [
    "Пользователь",
    "Модератор",
    "Админитратор"
];


/***/ }),

/***/ 7766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(9815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var nprogress__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4865);
/* harmony import */ var nprogress__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(nprogress__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_Navbar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(769);
/* harmony import */ var _components_Footer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(487);
/* harmony import */ var _components_Dialog__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9500);
/* harmony import */ var _components_Authenticated__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8653);
/* harmony import */ var _lib_user__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6448);
/* harmony import */ var _types_dialog_interface__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3366);
/* harmony import */ var _lib_misc_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1761);
/* harmony import */ var _styles_Library_module_css__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4980);
/* harmony import */ var _styles_Library_module_css__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_styles_Library_module_css__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _utils_strings_util__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(1977);


















var styles = (_styles_Library_module_css__WEBPACK_IMPORTED_MODULE_12___default());
var Page = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var keyStrings = {
        title: "Название",
        description: "Описание",
        subject: "Предмет",
        timeMinutes: "Минут на выполнение",
        totalQuestions: "Вопросов",
        totalCompletions: "Прохождений",
        createdAt: "Создан",
        lastEditedAt: "Последний раз изменён",
        publishedAt: "Опубликован",
        author: "Автор"
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]), library = ref[0], setLibrary = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("Загружаем ваши тесты..."), loadingMessage = ref1[0], setLoadingMessage = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isLoadingFinished = ref2[0], setIsLoadingFinished = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), errorMessage = ref3[0], setErrorMessage = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), searchQuery = ref4[0], setSearchQuery = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isFiltered = ref5[0], setIsFiltered = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)("creationDate"), sortOrder = ref6[0], setSortOrder = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null), selectedTest = ref7[0], setSelectedTest = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), isTestDialogOpened = ref8[0], setIsTestDialogOpened = ref8[1];
    var isLibraryFetchingStarted = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(false);
    var filterLibrary = function(library) {
        return library.filter(function(item) {
            var lowerCaseSearchQuery = searchQuery.toLowerCase();
            var matchesName = item.title.toLowerCase().includes(lowerCaseSearchQuery);
            var matchesDescription = item.description.toLowerCase().includes(lowerCaseSearchQuery);
            return matchesName || matchesDescription;
        });
    };
    var fetchLibrary = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
            var accessToken, responce, test;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        nprogress__WEBPACK_IMPORTED_MODULE_4___default().start();
                        if (false) {}
                        accessToken = localStorage.getItem("accessToken") || "";
                        return [
                            4,
                            fetch("/api/v1/tests/created", {
                                headers: {
                                    authorization: accessToken
                                }
                            })
                        ];
                    case 1:
                        responce = _state.sent();
                        if (!responce.ok) {
                            switch(responce.status){
                                case 429:
                                    {
                                        return [
                                            2,
                                            setErrorMessage("Вы отправляете слишком много запросов.")
                                        ];
                                    }
                                case 503:
                                    {
                                        return [
                                            2,
                                            setErrorMessage("Сервис управления тестами недоступен.")
                                        ];
                                    }
                                default:
                                    {
                                        return [
                                            2,
                                            setErrorMessage("Не удалось загрузить библиотеку тестов.")
                                        ];
                                    }
                            }
                        }
                        return [
                            4,
                            responce.json()
                        ];
                    case 2:
                        test = _state.sent();
                        setLoadingMessage("");
                        setIsLoadingFinished(true);
                        return [
                            2,
                            setLibrary(test.data.tests)
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchLibrary() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (!isLibraryFetchingStarted.current) {
            isLibraryFetchingStarted.current = true;
            fetchLibrary().then(function() {
                nprogress__WEBPACK_IMPORTED_MODULE_4___default().done();
            });
        }
    }, []);
    var filteredData = filterLibrary(library);
    var sortedData = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(filteredData).sort(function(a, b) {
        switch(sortOrder){
            case "creationDate":
                return b.createdAt - a.createdAt;
            case "publishedDate":
                return b.createdAt - a.createdAt;
            case "lastEditedDate":
                return b.lastEditedAt - a.lastEditedAt;
            case "completions":
                return b.userCompletions.length - a.userCompletions.length;
            case "name":
                return a.title.localeCompare(b.title);
        }
    });
    var handleSortChange = function(e) {
        setSortOrder(e.target.value);
    };
    var handleSearchChange = function(e) {
        var input = e.target.value;
        setSearchQuery(input);
        setIsFiltered(true);
    };
    var getTestState = function(test) {
        var editedState = "";
        var publishedState = test.published ? "опубликован" : "не опубликован";
        if (test.createdAt == test.lastEditedAt && !test.published) {
            editedState = "Создан";
        }
        if (test.draft) {
            editedState = "Изменён";
        }
        if (!test.draft && test.published) {
            editedState = "Изменений нет";
        }
        return editedState ? "".concat(editedState, ", ").concat(publishedState) : (0,_utils_strings_util__WEBPACK_IMPORTED_MODULE_16__/* .capitalize */ .k)(publishedState);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Authenticated__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                requiredRole: _lib_user__WEBPACK_IMPORTED_MODULE_9__/* .UserRole.USER */ .i4.USER,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: styles.container,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Navbar__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                            className: styles.main,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                    style: {
                                        marginBottom: 10
                                    },
                                    children: [
                                        "Ваши тесты",
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            href: "/tests/create",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                className: "fas fa-plus-square"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: styles.filters,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: styles.search,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                type: "text",
                                                className: styles["search-input"],
                                                placeholder: "Поиск в созданных тестах...",
                                                value: searchQuery,
                                                onChange: handleSearchChange
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: styles.sort,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    className: styles["sort-text"],
                                                    children: "Сортировать по:"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                                                    className: styles["filter-selector"],
                                                    value: sortOrder,
                                                    onChange: handleSortChange,
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                            value: "creationDate",
                                                            children: "Дате создания"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                            value: "publishedDate",
                                                            children: "Дате публикации"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                            value: "lastEditedDate",
                                                            children: "Дате последнего изменения"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                            value: "name",
                                                            children: "Названию"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                            value: "completions",
                                                            children: "Прохождениям"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    style: {
                                        marginTop: 5
                                    },
                                    children: [
                                        "Найдено тестов: ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                            children: library.length
                                        }),
                                        "."
                                    ]
                                }),
                                isFiltered && searchQuery && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        "Найдено результатов: ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                            children: sortedData.length
                                        }),
                                        "."
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: styles.tests,
                                    children: sortedData.map(function(item) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: styles.test,
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: styles["test-subject"],
                                                    children: _lib_misc_constants__WEBPACK_IMPORTED_MODULE_11__/* .subjectsStrings */ .YG[item.subject]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: styles["test-title"],
                                                    children: item.title
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: styles["test-description"],
                                                    children: item.description
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: styles["test-questions"],
                                                    children: [
                                                        "Вопросов: ",
                                                        item.totalQuestions || 0,
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                        "Прохождений: ",
                                                        item.userCompletions.length,
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                            children: getTestState(item)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    className: styles.button,
                                                    onClick: function() {
                                                        setIsTestDialogOpened(true);
                                                        setSelectedTest(item);
                                                    },
                                                    children: "Открыть"
                                                })
                                            ]
                                        }, item.id);
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "/tests/create",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: styles.button,
                                        children: "Создать тест"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Footer__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Dialog__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                opened: isLoadingFinished && library.length == 0,
                title: "Ваши тесты",
                description: "У вас не создано ни одного теста. Создать?",
                dismissable: false,
                type: _types_dialog_interface__WEBPACK_IMPORTED_MODULE_10__/* .DialogType.QUESTION */ .i.QUESTION,
                onClose: function(confirmed) {
                    if (confirmed) {
                        return router.push({
                            pathname: "/tests/create"
                        });
                    }
                    return router.push({
                        pathname: "/"
                    });
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Dialog__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                opened: isTestDialogOpened,
                dismissable: true,
                title: '"'.concat(selectedTest === null || selectedTest === void 0 ? void 0 : selectedTest.title, '" - ').concat(_lib_misc_constants__WEBPACK_IMPORTED_MODULE_11__/* .subjectsStrings */ .YG[selectedTest === null || selectedTest === void 0 ? void 0 : selectedTest.subject]),
                description: "**".concat(selectedTest === null || selectedTest === void 0 ? void 0 : selectedTest.description, "**\n\n") + Object.entries(selectedTest || {}).map(function(param) {
                    var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
                    if (keyStrings[key] && value !== null && value !== undefined && key !== "title" && key !== "subject" && key !== "description") {
                        if (key == "author") {
                            var author = value;
                            value = author.firstName ? "".concat(author.firstName, " ").concat(author.lastName) : author.username;
                        }
                        if (key == "userCompletions") {
                            var userCompletions = value;
                            value = userCompletions === null || userCompletions === void 0 ? void 0 : userCompletions.length;
                        }
                        if (key == "createdAt" || key == "lastEditedAt" || key == "publishedAt") {
                            var timestamp = value;
                            if (typeof value == "string") {
                                value = timestamp;
                            } else if (value !== 0 && value !== null && value !== undefined) {
                                value = new Date(timestamp).toLocaleString("ru");
                            }
                        }
                        return "".concat(keyStrings[key], ": **").concat(value, "**");
                    }
                }).filter(function(line) {
                    return line === null || line === void 0 ? void 0 : line.length;
                }).join("\n"),
                type: _types_dialog_interface__WEBPACK_IMPORTED_MODULE_10__/* .DialogType.QUESTION */ .i.QUESTION,
                confirmButtonName: "Редактировать",
                cancelButtonName: "Закрыть",
                onClose: function(confirmed) {
                    if (confirmed) {
                        setIsTestDialogOpened(false);
                        router.push({
                            pathname: "/tests/edit",
                            query: {
                                id: selectedTest === null || selectedTest === void 0 ? void 0 : selectedTest.id
                            }
                        });
                    } else {
                        setIsTestDialogOpened(false);
                    }
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Dialog__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                opened: !!loadingMessage,
                dismissable: false,
                title: "Один момент...",
                description: loadingMessage,
                type: _types_dialog_interface__WEBPACK_IMPORTED_MODULE_10__/* .DialogType.NONE */ .i.NONE
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Dialog__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                opened: !!errorMessage,
                title: "Ошибка",
                dismissable: false,
                description: errorMessage,
                type: _types_dialog_interface__WEBPACK_IMPORTED_MODULE_10__/* .DialogType.INFO */ .i.INFO,
                onClose: function() {
                    setErrorMessage("");
                    router.push({
                        pathname: "/"
                    });
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Page);


/***/ }),

/***/ 1977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ uncapitalize; },
/* harmony export */   "k": function() { return /* binding */ capitalize; }
/* harmony export */ });
/**
 * Replaces the first letter of input with upper-case letter.
 * @param input String input.
 * @returns Output with first letter replaced with upper-case letter.
 */ function capitalize(input) {
    var ref;
    return (input === null || input === void 0 ? void 0 : (ref = input[0]) === null || ref === void 0 ? void 0 : ref.toUpperCase()) + (input === null || input === void 0 ? void 0 : input.slice(1));
}
/**
 * Replaces the first letter of input with lower-case letter.
 * @param input String input.
 * @returns Output with first letter replaced with lower-case letter.
 */ function uncapitalize(input) {
    var ref;
    return (input === null || input === void 0 ? void 0 : (ref = input[0]) === null || ref === void 0 ? void 0 : ref.toLowerCase()) + (input === null || input === void 0 ? void 0 : input.slice(1));
}


/***/ }),

/***/ 4980:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Library_container__N9P53","main":"Library_main__hNF9n","filters":"Library_filters__0HSCv","sort":"Library_sort__RQNiU","search":"Library_search__sUd1S","search-input":"Library_search-input__ngwvV","filter-selector":"Library_filter-selector__6vZi_","test-title":"Library_test-title__txJ9d","test-description":"Library_test-description__wuBUF","test-questions":"Library_test-questions__rLVgg","button":"Library_button__3a24C","tests":"Library_tests__9DNPy","test":"Library_test__d1_yQ","test-subject":"Library_test-subject__Cc58h","sort-text":"Library_sort-text__kYy15"};

/***/ }),

/***/ 9815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(3375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(1566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [106,480,774,888,179], function() { return __webpack_exec__(9868); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);